<!--新闻中心-移动端-->
<template>
  <div id="news">
    <div class="search-box">
      <form action="/">
        <form action="/">
          <search-item
            :placeholder="$t('新闻中心 | 新闻资讯')"
            @search="searchView"
            @cancel="cancelView"
            clstag="newscenter|keycount|news-H5|seatch"
          ></search-item>
        </form>
      </form>
    </div>
    <div class="seach-content" v-if="goSearch">
      <van-list
        v-model="loading"
        :finished="finished"
        :loading-text="$t('加载中...')"
        :finished-text="finishedText"
        @load="searchApiView()"
        v-if="hasSearchData"
      >
        <div class="content">
          <trends-list :data="searchData"></trends-list>
        </div>
      </van-list>
      <van-empty
        v-else
        class="custom-image img-list-box"
        :image="require('@/assets/img-m/no-list.png')"
        :description="$t('暂无数据')"
      />
    </div>
    <van-tabs
      scrollspy
      type=""
      sticky
      v-else
      @click="navClick"
      v-model="active"
    >
      <van-tab v-for="(item, index) in dataTab" :key="index" :title="item.name">
        <div class="main">
          <div v-if="index == 0">
            <van-swipe
              class="my-swipe"
              :autoplay="3000"
              indicator-color="white"
            >
              <van-swipe-item
                v-for="(item, index) in dataBanner"
                :key="index"
                v-lazy:background-image="item.appHeader"
                class="banner"
                @click="jumpDetail(item)"
              ></van-swipe-item>
            </van-swipe>
            <a
              href="#"
              :class="language === 'en-US' ? 'register-en' : 'register'"
              clstag="newscenter|keycount|news-H5|register"
              v-if="!isLogin"
              @click="jumpLogin"
              ><b class="btn">{{ $t('立即登录') }}</b></a
            >
          </div>
          <section
            class="section"
            v-if="dataArr.length > 0 && dataArr[index].length > 0"
          >
            <div class="title-h3" v-if="showTabTitle(item)">
              <span>{{ item.name }}</span>
              <router-link
                :to="{
                  name: item.code.includes('News Trends')
                    ? 'mobile_trends'
                    : item.code.includes('CIFTIS Stories')
                    ? 'mobile_stories'
                    : 'mobile_notice',
                  query: {
                    code: item.code.replace(/1$/, '')
                  }
                }"
                v-if="
                  item.code.includes('News Trends') ||
                    item.code.includes('Latest Notice') ||
                    item.code.includes('CIFTIS Stories')
                "
                class="title-more"
                :clstag="`newscenter|keycount|news-H5|link-${item.code}`"
              >
                {{ $t('查看全部') }}
              </router-link>
            </div>
            <!-- 新闻动态 -->
            <div
              class="content dynamic-new"
              v-if="item.code.includes('News Trends')"
            >
              <news-list :data="dataArr[index]" :length="5"></news-list>
            </div>
            <!-- 最新通知 -->
            <div
              class="content notice"
              v-if="item.code.includes('Latest Notice')"
            >
              <notice-list :data="dataArr[index]" :length="6"></notice-list>
            </div>
            <!--服贸故事-->
            <div
              class="content stories"
              v-if="item.code.includes('CIFTIS Stories')"
            >
              <story-list :data="dataArr[index]" :length="6"></story-list>
            </div>
            <!-- 预约申请 -->
            <div
              class="content apply"
              v-if="item.code.includes('Appointment Applications')"
            >
              <dl
                v-for="(item, index) in dataArr[index]"
                :key="index"
                :clstag="`newscenter|keycount|news-H5|link-${item.title}`"
                @click="jumpDetail(item)"
              >
                <dt :class="item.appHeader ? '' : 'base-bg'">
                  <div class="img" v-lazy:background-image="item.appHeader" />
                </dt>
                <dd>{{ item.title }}</dd>
              </dl>
            </div>
            <!-- 媒体服务 -->
            <div
              class="content media"
              v-if="item.code.includes('Media Services')"
            >
              <div
                class="list"
                v-for="(item, index) in dataArr[index]"
                :key="index"
              >
                <div
                  @click="jumpDetail(item)"
                  v-lazy:background-image="item.appHeader"
                  :clstag="`newscenter|keycount|news-H5|link-${item.title}`"
                >
                  <p>{{ item.title }}</p>
                </div>
              </div>
            </div>
            <!-- 资料中心 -->
            <div
              class="content download"
              v-if="item.code.includes('Data Center')"
            >
              <div
                v-for="(item, index) in dataArr[index]"
                :key="index"
                class="list"
              >
                <div
                  v-lazy:background-image="item.appHeader"
                  @click="jumpDetail(item)"
                  :clstag="`newscenter|keycount|news-H5|link-${item.title}`"
                  :style="{ 'background-position': 'center' }"
                >
                  <div>
                    <!-- <h3>{{ item.title }}</h3> -->
                    <p v-if="language != 'en-US'">{{ item.brief }}</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { getLang } from '@/utils'
import Cookie from 'js-cookie'
import getTranslation from '@/locale/getTranslation'
import '@/assets/css/media-new.scss'
import NewsList from './components/newsList'
import NoticeList from './components/noticeList'
import StoryList from './components/storyList'
import TrendsList from './components/trendsList'
import searchItem from './components/searchItem' //注册搜索组件
import { describeNavigatorsApi, getListApi, searchApi } from '@/api/news'
import { getUserInfo } from '@/api/registry-api'

import jumpDetail from './mixin/jumpDetail.js'
export default {
  mixins: [jumpDetail],
  components: { NewsList, NoticeList, StoryList, TrendsList, searchItem },
  data() {
    return {
      language: getLang(),
      active: 0,
      //搜索
      searchValue: '',
      cancelShow: false,
      //加载
      loading: false,
      finished: false,
      hasSearchData: true,
      goSearch: false,
      finishedText: '',
      pageNum: 1,
      searchData: [],
      //page
      dataTab: [],
      dataArr: [],
      dataBanner: [],
      isMedia: false,
      isLogin: false,
      registerUrl: 'http://www.baidu.com'
    }
  },
  beforeCreate() {
    this.$toast.loading({
      duration: 0,
      message: getTranslation('加载中...'),
      forbidClick: true
    })
  },
  mounted() {
    this.getNavigation()
    this.getBannerView()
    try {
      let options = {
        source: 'newsCenter',
        isShow: false
      }
      window.bridge.onShowShareButton(JSON.stringify(options))
    } catch (error) {
      console.log('APP隐藏分享按钮监听失败')
    }
    if (Cookie.get('ciftis_at')) {
      try {
        let options = {
          source: 'newsCenter',
          isShow: true
        }
        window.bridge.titleBarRightButton(JSON.stringify(options))
      } catch (error) {
        console.log('APP日历显示监听失败')
      }
    }
    let timeInterval = setInterval(() => {
      if (document.getElementById('news')) {
        window.scrollBy(0, 100)
        clearInterval(timeInterval)
      }
    }, 100)
  },
  beforeDestroy() {
    try {
      let options = {
        source: 'newsCenter',
        isShow: false
      }
      window.bridge.titleBarRightButton(JSON.stringify(options))
    } catch (error) {
      console.log('APP日历显示监听失败')
    }
  },
  methods: {
    showTabTitle(item) {
      return !/^Data Center/.test(item.code)
    },
    async getNavigation() {
      //判断是否登录并获取用户信息
      const getUser = new Promise(resolve => {
        const ciftis_at = Cookie.get('ciftis_at')
        if (ciftis_at) {
          getUserInfo()
            .then(res => {
              this.isLogin = true
              if (res.data.accountType === 'MEDIA') this.isMedia = true
              resolve()
            })
            .catch(() => {
              resolve()
            })
        } else {
          resolve()
        }
      })
      //获取tabs
      const getTabs = new Promise((resolve, reject) => {
        describeNavigatorsApi()
          .then(res => {
            const data = res.result.data.filter(elm => {
              if (
                elm.code.includes('News Trends') ||
                elm.code.includes('Latest Notice') ||
                elm.code.includes('CIFTIS Stories') ||
                elm.code.includes('Media Services') ||
                elm.code.includes('Appointment Applications') ||
                elm.code.includes('Data Center')
              ) {
                return elm
              }
            })
            this.dataTab = data
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
      Promise.all([getUser, getTabs]).then(() => {
        this.getDetailView()
      })
    },
    navClick() {
      const code = this.dataTab[this.active].code
      const normalizedCode = code.replace(/1$/, '')
      const needLoginCodes = ['Appointment Applications', 'Media Services']
      if (!this.isMedia && needLoginCodes.includes(normalizedCode)) {
        this.jumpLogin()
      }
    },
    jumpLogin() {
      try {
        window.bridge.startLoginPage(
          JSON.stringify({
            source: 'mediaCenter', // 注册：register， 忘记密码：forgetPsw， 预约系统： orderSystem
            type: 'media' // 个人用户登录：personal, 企业用户登录：company
          })
        )
      } catch (err) {
        this.$router.push({ name: 'mobile_login' })
        console.log('APP跳转登录失败')
      }
    },
    async getBannerView() {
      const res = await getListApi({
        cls: 'Focus News'
      })
      this.dataBanner = res.result.infos
    },
    async getDetailView() {
      const _self = this
      let lang = Cookie.get('ciftis_site_lang')
      let apiArr = []
      this.dataTab.forEach((elm, idx) => {
        let code = lang === 'en-US' ? elm.name : elm.code
        let detailApi = new Promise((resolve, reject) => {
          _self.dataArr.push([])
          if (
            this.isMedia ||
            !['Appointment Applications', 'Media Services'].includes(code)
          ) {
            getListApi({
              cls: code,
              pageNum: '1',
              pageSize: '10'
            })
              .then(res => {
                const list = res.result.infos
                _self.$set(_self.dataArr, idx, list)
                resolve()
              })
              .catch(() => {
                reject()
              })
          } else {
            resolve()
          }
        })
        apiArr.push(detailApi)
      })
      Promise.all(apiArr)
        .then(() => {
          this.$toast.clear()
        })
        .catch(() => {
          this.$toast.clear()
        })
    },
    async searchApiView() {
      let pageNum = this.pageNum
      const options = {
        query: this.searchValue,
        filter: `cateId:portal`,
        pageNum,
        pageSize: 10
      }
      const res = await searchApi(options)
      if (res && res.result && res.result.data) {
        let { resultdata, resultcount, pageCount } = res.result.data
        if (resultcount == 0) {
          this.hasSearchData = false
        } else {
          this.hasSearchData = true
          this.searchData = this.searchData.concat(resultdata)
          this.loading = false
          this.pageNum = pageNum += 1
          if (this.pageNum > pageCount) {
            this.finished = true
            this.finishedText = `—  ${getTranslation(
              '共'
            )}${resultcount}${getTranslation('条结果')}  —`
          }
        }
      } else {
        this.loading = false
        this.hasSearchData = false
      }
    },
    searchView(val) {
      this.searchValue = val
      this.goSearch = true
      this.clearSearchData()
    },
    cancelView() {
      this.goSearch = false
      this.clearSearchData()
    },
    //清空搜索数据
    clearSearchData() {
      this.pageNum = 1
      this.searchData = []
      this.hasSearchData = true
      this.finished = false
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';
.search-box,
form {
  width: 100%;
  height: 1rem;
  @include linearBg();
  overflow: hidden;
  /deep/.van-search {
    padding: 0.1rem 0.3rem 0.2rem;
  }
}
/deep/.van-tabs__wrap {
  height: 60px;
  .van-tabs__nav {
    padding: 0 10px;
    font-size: 14px;
    font-weight: 500;
    .van-tab {
      -webkit-flex-basis: auto !important;
      -ms-flex-basis: auto !important;
      -moz-flex-basis: auto !important;
      flex-basis: auto !important;
      line-height: 30px;
      height: 30px;
      margin: 15px 0;
      .van-tab__text {
        box-sizing: border-box;
        min-width: 75px;
        text-align: center;
        padding: 0 11px;
      }
    }
    .van-tab--active {
      .van-tab__text {
        border: 1px solid $themeColor;
        border-radius: 15px;
        color: $themeColor;
      }
    }
  }
}
/deep/.van-sticky--fixed {
  border: 0;
  top: -0.01rem;
  .van-tabs__nav {
    @include linearBg();
    .van-tab__text {
      color: #fff;
    }
    .van-tab--active {
      .van-tab__text {
        border: 1px solid #fff;
        color: #fff;
      }
    }
  }
}
</style>
